/* countdown-feature.js — Controller für Countdown in image-hero & slideshow_stiletto.
   - berechnet Zustand (before/active/expired) aus Browserzeit
   - tickt die Ziffern selbst (theme.js initialisiert [data-countdown-timer] hier NICHT)
   - friert bei 0 ein (kein Negativlauf), kein Auto-Rücksprung
   - Fail-safe: ungültige/leere Konfig -> Normalzustand
   - Diashow: Swiper-Autoplay pausieren + Slides aria-hidden
   - bfcache (pageshow) + Theme-Editor (designMode, shopify:section:load) */
(function () {
  'use strict';

  function buildEpoch(p, tzMode, shopOffset) {
    if (!p || !p.year || !p.month || !p.day) return NaN;
    var y = +p.year, mo = +p.month - 1, d = +p.day, h = +(p.hour || 0), mi = +(p.minute || 0);
    if ([y, mo, d, h, mi].some(function (n) { return isNaN(n); })) return NaN;
    if (tzMode === 'user') return new Date(y, mo, d, h, mi, 0).getTime();
    var off = shopOffset || '+0000';
    var sign = off.charAt(0) === '-' ? -1 : 1;
    var oh = parseInt(off.slice(1, 3), 10) || 0;
    var om = parseInt(off.slice(3, 5), 10) || 0;
    return Date.UTC(y, mo, d, h, mi, 0) - sign * (oh * 60 + om) * 60000;
  }

  function computeEnd(cfg) {
    var s = buildEpoch(cfg.start, cfg.timeZone, cfg.shopOffset);
    var e = buildEpoch(cfg.end, cfg.timeZone, cfg.shopOffset);
    return { start: s, end: e, valid: !isNaN(s) && !isNaN(e) && s < e };
  }

  function stateFor(times, now) {
    if (!times.valid) return 'expired';        // Fail-safe -> Normalzustand
    if (now < times.start) return 'before';
    if (now < times.end) return 'active';
    return 'expired';
  }

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function Controller(root) {
    var cfgEl = root.querySelector('[data-countdown-config]');
    if (!cfgEl) return;
    try { this.cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    this.root = root;
    this.els = {
      d: root.querySelector('[data-days]'),
      h: root.querySelector('[data-hours]'),
      m: root.querySelector('[data-minutes]'),
      s: root.querySelector('[data-seconds]')
    };
    this.interval = null;
    var self = this;
    this._tick = function () { if (!self.render()) self.stopTicking(); };
    this.evaluate();
    window.addEventListener('pageshow', function (ev) { if (ev.persisted) self.evaluate(); });
  }

  Controller.prototype.stopTicking = function () {
    if (this.interval) { clearInterval(this.interval); this.interval = null; }
  };

  Controller.prototype.evaluate = function () {
    this.stopTicking();
    var designMode = !!(window.Shopify && window.Shopify.designMode);
    this.times = computeEnd(this.cfg);
    var state = designMode ? 'active' : stateFor(this.times, Date.now());
    this.root.setAttribute('data-countdown-state', state);
    if (state === 'active') {
      this.render();
      if (!designMode && this.times.valid) this.interval = setInterval(this._tick, 1000);
      this.markSlides(true);
      this.pauseSwiper(0);
    } else {
      this.markSlides(false);
    }
  };

  Controller.prototype.render = function () {
    if (!this.times.valid) return false;
    var diff = Math.floor((this.times.end - Date.now()) / 1000);
    if (diff < 0) diff = 0;
    var d = Math.floor(diff / 86400);
    var h = Math.floor((diff % 86400) / 3600);
    var m = Math.floor((diff % 3600) / 60);
    var s = diff % 60;
    if (this.els.d) this.els.d.textContent = d;
    if (this.els.h) this.els.h.textContent = pad(h);
    if (this.els.m) this.els.m.textContent = pad(m);
    if (this.els.s) this.els.s.textContent = pad(s);
    return diff > 0; // false -> bei 0 einfrieren
  };

  Controller.prototype.markSlides = function (hidden) {
    var slides = this.root.querySelectorAll('.swiper-slide');
    for (var i = 0; i < slides.length; i++) {
      if (hidden) slides[i].setAttribute('aria-hidden', 'true');
      else slides[i].removeAttribute('aria-hidden');
    }
  };

  Controller.prototype.pauseSwiper = function (tries) {
    var el = this.root.querySelector('.swiper');
    var sw = el && el.swiper;
    if (sw && sw.autoplay) { try { sw.autoplay.stop(); } catch (e) {} return; }
    if (tries < 30) {
      var self = this;
      setTimeout(function () { self.pauseSwiper(tries + 1); }, 100);
    }
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-countdown-root]');
    for (var i = 0; i < roots.length; i++) {
      if (!roots[i].__countdownInit) {
        roots[i].__countdownInit = true;
        new Controller(roots[i]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme-Editor: Section neu geladen -> erneut initialisieren
  document.addEventListener('shopify:section:load', function (ev) { init(ev.target); });
})();
